import type { FC, RefAttributes } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";
import type { ComponentRef, ComponentPropsWithoutRef } from "react";

const Tabs = TabsPrimitive.Root;

const TabsList: FC<
  ComponentPropsWithoutRef<typeof TabsPrimitive.List> & RefAttributes<ComponentRef<typeof TabsPrimitive.List>>
> = ({ ref, className, ...props }) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      className,
    )}
    {...props}
  />
);
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger: FC<
  ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & RefAttributes<ComponentRef<typeof TabsPrimitive.Trigger>>
> = ({ ref, className, ...props }) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      className,
    )}
    {...props}
  />
);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent: FC<
  ComponentPropsWithoutRef<typeof TabsPrimitive.Content> & RefAttributes<ComponentRef<typeof TabsPrimitive.Content>>
> = ({ ref, className, ...props }) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className,
    )}
    {...props}
  />
);
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
